import APIS from "../constant/EndPoint";
import useGetHook from "./useGetHook";
interface IUsePostHook {
  allowedPermissions?: string[];
}
const usePermission = (props?: IUsePostHook) => {
  const allowedPermissions =  props && props.allowedPermissions ? props.allowedPermissions : [];
  const { data, isLoading } = useGetHook({
    queryKey: [`user-profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });
 const isSuperUser = data?.is_superuser;

  if (isSuperUser) {
    return { isAllowed: true, isSuperUser, isLoading };
  }
  const permissionsLists: any =
    data?.groups?.map((item: any) => item.custom_permissions).flat() || [];
  const isAllowed: boolean = permissionsLists?.some(
    (permission: any) =>
      allowedPermissions.includes(permission) ||
      allowedPermissions.includes("no-permission-required")
  );
  return { isAllowed, isSuperUser, isLoading };
};

export default usePermission;
